module.exports = __webpack_public_path__ + "static/media/IlotA_mall_1.bd787366.webp";